/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamCorrectionGridExampublishidQueryResponse,
  GetApiV1ExamCorrectionGridExampublishidPathParams,
  GetApiV1ExamCorrectionGridExampublishidQueryParams,
  GetApiV1ExamCorrectionGridExampublishid400,
  GetApiV1ExamCorrectionGridExampublishid401,
  GetApiV1ExamCorrectionGridExampublishid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionGridExampublishid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamCorrectionGridExampublishid } from "../../clients/examCorrectionDashboardController/getApiV1ExamCorrectionGridExampublishid.ts";

export const getApiV1ExamCorrectionGridExampublishidQueryKey = (
  examPublishId: GetApiV1ExamCorrectionGridExampublishidPathParams["examPublishId"],
  params?: GetApiV1ExamCorrectionGridExampublishidQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/correction-grid/:examPublishId",
      params: { examPublishId: examPublishId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamCorrectionGridExampublishidQueryKey = ReturnType<
  typeof getApiV1ExamCorrectionGridExampublishidQueryKey
>;

export function getApiV1ExamCorrectionGridExampublishidQueryOptions(
  examPublishId: GetApiV1ExamCorrectionGridExampublishidPathParams["examPublishId"],
  params?: GetApiV1ExamCorrectionGridExampublishidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamCorrectionGridExampublishidQueryKey(
    examPublishId,
    params,
  );
  return queryOptions<
    GetApiV1ExamCorrectionGridExampublishidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionGridExampublishid400
      | GetApiV1ExamCorrectionGridExampublishid401
      | GetApiV1ExamCorrectionGridExampublishid500
    >,
    GetApiV1ExamCorrectionGridExampublishidQueryResponse,
    typeof queryKey
  >({
    enabled: !!examPublishId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamCorrectionGridExampublishid(examPublishId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a subgrade de correção de texto para um item específico do exame dentro de uma publicação de exame com paginação. **(Requer Authorization para autenticação)**
 * @summary Subgrade de correção de exame de carga (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-grid/:examPublishId}
 */
export function useGetApiV1ExamCorrectionGridExampublishid<
  TData = GetApiV1ExamCorrectionGridExampublishidQueryResponse,
  TQueryData = GetApiV1ExamCorrectionGridExampublishidQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamCorrectionGridExampublishidQueryKey,
>(
  examPublishId: GetApiV1ExamCorrectionGridExampublishidPathParams["examPublishId"],
  params?: GetApiV1ExamCorrectionGridExampublishidQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamCorrectionGridExampublishidQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamCorrectionGridExampublishid400
          | GetApiV1ExamCorrectionGridExampublishid401
          | GetApiV1ExamCorrectionGridExampublishid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamCorrectionGridExampublishidQueryKey(examPublishId, params);

  const query = useQuery(
    {
      ...getApiV1ExamCorrectionGridExampublishidQueryOptions(
        examPublishId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionGridExampublishid400
      | GetApiV1ExamCorrectionGridExampublishid401
      | GetApiV1ExamCorrectionGridExampublishid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
